export default defineNuxtPlugin(async () => {
    const seoMapState = useState<Record<string, string>>('categorySeoMap', () => ({}));
    const seoMapCountState = useState<number>('categorySeoMapCount', () => 0);

    // Avoid refetch if already populated (e.g., during client hydration)
    if (seoMapState.value && Object.keys(seoMapState.value).length > 0) {
        return;
    }

    try {
        const data = await $fetch<any>('/api/categories/seo-map');
        // Back-compat: API may return either a plain map or an object { map, count }
        if (data && typeof data === 'object') {
            if (data.map && typeof data.map === 'object') {
                seoMapState.value = data.map as Record<string, string>;
                if (typeof data.count === 'number') seoMapCountState.value = data.count;
                else seoMapCountState.value = Object.keys(seoMapState.value).length;
            } else {
                // Legacy plain map
                seoMapState.value = data as Record<string, string>;
                seoMapCountState.value = Object.keys(seoMapState.value).length;
            }
        }
    } catch (e) {
        // Silently ignore; consumers should handle missing entries gracefully
    }
});
